import { lastValueFrom } from 'rxjs';
import { BaseService } from './base-service';
export class StoredFileService {
    static downloadStoredFile(oid) {
        BaseService.downloadFile(`stored-file/${oid}`, null, null);
    }
    static uploadStoredFile(file) {
        return lastValueFrom(BaseService.uploadFile(`stored-file`, file));
    }
    static deleteStoredFile(oid) {
        return lastValueFrom(BaseService.delete(`stored-file/${oid}`));
    }
    static getStoredFileUrl(oid) {
        return BaseService.getFileUrl(`stored-file/${oid}`);
    }
}
